import React from 'react';
import useDeleteCallLisRecord from '../../../../mutations/useDeleteCallLisRecord';
import { Button, Col, Icon, Tooltip } from 'antd';
import { useIsDispatcher } from '../../../../hooks/useIsDispatcher';

const DeleteCallLisRecord = ({ recordId, requestId }) => {
  const { isLoading, deleteCallLisRecord } = useDeleteCallLisRecord();

  const isDispatcher = useIsDispatcher();

  const handleDownloadClick = async () => {
    await deleteCallLisRecord({ recordId, requestId });
  };

  if (!isDispatcher) return null;

  return (
    <Col span={2} style={{ textAlign: 'center' }}>
      <Tooltip title="Отвязать звонок от заявки">
        <Button
          shape="circle"
          loading={isLoading}
          onClick={handleDownloadClick}
          style={{
            top: '-11px',
            color: '#b7b7b7',
            border: 'none',
            fontSize: 16,
          }}
        >
          <Icon type="delete" style={{ color: 'red' }} />
        </Button>
      </Tooltip>
    </Col>
  );
};

export default DeleteCallLisRecord;
